import $ from 'jquery';

$('.c-loadmore').on('click', function (event) {

	event.preventDefault();

	var canBeLoaded = false, // this param allows to initiate the AJAX call only if necessary
			bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

		var data = {
			action: 'loadmore',
			query: convertiv_loadmore_params.posts,
			page: convertiv_loadmore_params.current_page
		};

			const button = $(this);

			//$(this).hide();

			$.ajax({
				url: convertiv_loadmore_params.ajaxurl,
				data: data,
				type: 'POST',
				beforeSend: function(xhr) {
					canBeLoaded = false;
					button.text(convertiv_loadmore_params.loading_str);
				}
			}).done(function(data) {
				if (data) {

					$('.c-thoughts').append(data);
					canBeLoaded = true;
					convertiv_loadmore_params.current_page++;

					if (convertiv_loadmore_params.current_page == convertiv_loadmore_params.max_page) {
						$('.c-loadmore-wrapper').remove();
						canBeLoaded = false;
					}
				} else {
					$('.c-loadmore-wrapper').remove();
					canBeLoaded = false;
				}
			}).always(function() {
				//button.text(convertiv_loadmore_params.loadmore_str);
			});

			//canBeLoaded = true;

			$(window).scroll(function() {

			var data = {
				action: 'loadmore',
				query: convertiv_loadmore_params.posts,
				page: convertiv_loadmore_params.current_page
			};

				if ($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded == true) {

					console.log(convertiv_loadmore_params.current_page);
					console.log(convertiv_loadmore_params.max_page);

					const button = $('.c-loadmore');

					$.ajax({
						url: convertiv_loadmore_params.ajaxurl,
						data: data,
						type: 'POST',
						beforeSend: function(xhr) {
							canBeLoaded = false;
							button.text(convertiv_loadmore_params.loading_str);
						},
						success: function(data) {
							if (data) {
								$('.c-thoughts').append(data);
								//canBeLoaded = true;
								convertiv_loadmore_params.current_page++;
								if (convertiv_loadmore_params.current_page == convertiv_loadmore_params.max_page) {
									$('.c-loadmore-wrapper').remove();
									canBeLoaded = false;
								} else {
									canBeLoaded = true;
								}
							}
						}
					});
				}
			});

		});
